import React, { useId } from 'react';

/** Shared ZFLIX mark for splash screens (matches App ZFlixLogo). */
export default function ZFlixSplashLogo({
  size = 'normal',
  className = '',
  iconOnly = false,
  iconPx,
}) {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  const gradId = `zflix-splash-zg-${uid}`;
  const filtId = `zflix-splash-zf-${uid}`;
  const small = size === 'small';
  const large = size === 'large';
  const dim = iconPx ?? (large ? 72 : small ? 40 : 56);
  const blur = iconPx ? Math.max(2, iconPx / 28) : large ? 3 : small ? 1.5 : 2;
  const wordSize = large ? 18 : small ? 11 : 15;
  const letterSpace = large ? 5 : small ? 2.5 : 3.5;

  const iconSvg = (
    <svg
      width={dim}
      height={dim}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden
      className="zflix-splash-logo-svg"
      shapeRendering="geometricPrecision"
    >
      <defs>
        <linearGradient id={gradId} x1="10" y1="8" x2="38" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#ffeef0" />
          <stop offset="35%" stopColor="#ff6b7a" />
          <stop offset="100%" stopColor="#e50914" />
        </linearGradient>
        <filter id={filtId} width="130%" height="130%" x="-15%" y="-15%">
          <feDropShadow dx="0" dy="1" stdDeviation={blur} floodColor="#000" floodOpacity="0.5" />
        </filter>
      </defs>
      <rect width="48" height="48" rx="8" fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.18)" strokeWidth="1" />
      <polygon points="6,6 42,6 42,17 20,31 42,31 42,42 6,42 6,31 28,17 6,17" fill={`url(#${gradId})`} filter={`url(#${filtId})`} />
    </svg>
  );

  if (iconOnly) {
    return (
      <div
        className={`zflix-splash-logo zflix-splash-logo--icon-only ${className}`.trim()}
        role="img"
        aria-label="ZFLIX"
      >
        {iconSvg}
      </div>
    );
  }

  return (
    <div
      className={`zflix-splash-logo ${className}`.trim()}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: large ? 8 : small ? 3 : 6 }}
      role="img"
      aria-label="ZFLIX"
    >
      {iconSvg}
      <span
        className="zflix-splash-logo-word"
        style={{
          fontSize: wordSize,
          fontWeight: 900,
          color: '#fff',
          letterSpacing: letterSpace,
          fontFamily: 'Arial Black, sans-serif',
          textShadow: '0 2px 8px rgba(0,0,0,0.85)',
        }}
      >
        ZFLIX
      </span>
    </div>
  );
}
